// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_x-z","videoWrapper":"ay-z","twoColumnImage":"by-z","imageCarouselBtn":"cy-z","carouselNextBtn":"dy-z","carouselPrevBtn":"ey-z"};